import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/AutomatedMarketing/customerList",{...params
    } )
}
function GET_SUMMARY(params) {
    return  axios.get("/statistics/AutomatedMarketing/summary",{
        params: {
            ...params
        }
    }  )
}
export default {
    GET_LIST,GET_SUMMARY
};
